/**
 *
 * @return fetch Object
 */
import { createFetchOptions } from '../create-fetch-options';
import { getHost } from '../get-host';
const BASE_URL = `https://${getHost()}.anwb.nl`;
export const request = (details, apiConfig = {}, apiHeader) => fetch(`${BASE_URL}${details.url}`, createFetchOptions(details, apiConfig, apiHeader));
